import TeamCard from "./TeamCard";
import silvanaImg from "../assets/images/silvana.jpg";
import gisellaImg from "../assets/images/gisella.jpg";
import sarahImg from "../assets/images/sarah.jpeg";
import larryImg from "../assets/images/larry.jpg";
import suzanneImg from "../assets/images/suzanne.jpg";
import carmenImg from "../assets/images/carmen.jpg";
import stefhaniImg from "../assets/images/stefhani.jpg";
import nimaImg from "../assets/images/nima.jpeg";
import FadeInSection from "./FadeInSection";

function Team() {
	return (
		<div className="team-container" id="team">
			<div className="container">
				<FadeInSection animationType="fade-up">
					<h2>Meet the Team</h2>
					<hr />
					<div className="row mt-5 gy-4">
						<div className="col-lg-4 col-md-6">
							<TeamCard
								name="Silvana"
								role="Stylist"
								img={silvanaImg}
								link="https://sil-styles.square.site/"
							/>
						</div>
						<div className="col-lg-4 col-md-6">
							<TeamCard
								name="Gisella"
								role="Stylist"
								img={gisellaImg}
								link="https://gistar-allure.square.site/"
							/>
						</div>
						<div className="col-lg-4 col-md-6">
							<TeamCard
								name="Suzanne"
								role="Stylist"
								img={suzanneImg}
								link="https://www.styledbysuzanne.com/"
							/>
						</div>
						<div className="col-lg-4 col-md-6">
							<TeamCard
								name="Sarah"
								role="Esthetician"
								img={sarahImg}
								link="https://linktr.ee/skin9studio"
							/>
						</div>
						<div className="col-lg-4 col-md-6">
							<TeamCard
								name="Larry"
								role="Stylist"
								img={larryImg}
								link="https://crafted-by-larry.square.site/"
							/>
						</div>
						<div className="col-lg-4 col-md-6">
							<TeamCard
								name="Carmen"
								role="Stylist"
								img={carmenImg}
								link="https://crownconfidence.square.site/"
							/>
						</div>
						<div className="col-lg-4 col-md-6">
							<TeamCard
								name="Stefhani"
								role="Massage Therapist"
								img={stefhaniImg}
								link="https://sasobodyharmony.square.site/"
							/>
						</div>
						<div className="col-lg-4 col-md-6">
							<TeamCard
								name="Nima"
								role="Waxing & Threading Specialist"
								img={nimaImg}
								link="https://nima-wax-studio.square.site/"
							/>
						</div>
					</div>
				</FadeInSection>
			</div>
		</div>
	);
}

export default Team;
